import React from 'react';
import styles from './Spinner.module.css';

const Spinner = ( props ) => (
    <div className = { styles.Spinner }>
        <div className = {styles.innerDiv}>
            <h1> Lets Art </h1>
        </div>
    </div>
    
);

export default Spinner;